// extracted by mini-css-extract-plugin
export default {"button":"NewModal_button__-uVWI","divider":"NewModal_divider__r0PSo","link":"NewModal_link__CaGxE"};